const FOCUSABLE_ELEMENTS =
  'a[href]:not([tabindex="-1"]), button:not([tabindex="-1"]), input:not([tabindex="-1"]), textarea:not([tabindex="-1"]), select:not([tabindex="-1"]), details:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';

const getChildren = (target: HTMLElement) =>
  Array.from(target.querySelectorAll(FOCUSABLE_ELEMENTS)).filter((x) =>
    x.checkVisibility(),
  ) as HTMLElement[];

const onElemKeydown = (target: HTMLElement) => (event: KeyboardEvent) => {
  const elements = getChildren(target);
  const isLastElement = event.target === elements.at(-1);
  const isFirstElement = event.target === elements.at(0);
  if (isFirstElement && isLastElement) {
    return;
  }
  if (event.code !== 'Tab') {
    return;
  }
  if (isLastElement && !event.shiftKey) {
    event.preventDefault();
    elements.at(0)?.focus();
  }
  if (isFirstElement && event.shiftKey) {
    event.preventDefault();
    elements.at(-1)?.focus();
  }
};

export const focusTrap = (target: HTMLElement, restoreFocus?: () => void) => {
  $effect(() => {
    const elements = getChildren(target);
    const initialTarget = elements.find((elem) => !!elem.dataset.initialfocus) ?? elements.at(0);
    initialTarget?.focus();

    const elemHandler = onElemKeydown(target);
    target.addEventListener('keydown', elemHandler);

    return () => {
      target.removeEventListener('keydown', elemHandler);
      restoreFocus?.();
    };
  });
};
